import React from 'react';
import { connect } from 'react-redux';
import withLayout from '@app/hocs/withLayout';
import Home from '@app/containers/Home';
import {
  getBanners,
  getCatBlog,
  getJobCollection,
  getQuickShortCut,
  getSeo,
} from '@app/containers/Home/actions';
import { loadConfigForm } from '@app/components/JsDatabase/action';
import { getRegions } from '@app/modules/region';

class Index extends React.Component {
  static async getInitialProps(ctx) {
    const { query, req, isMobile, isServer, store } = ctx;
    let referer = '';
    let cookieLocation = 'toan-quoc';
    let regionLocation = {
      regionValue: 0,
      regionUrl: 'toan-quoc',
      regionName: 'Toàn quốc',
      subRegionValue: 0,
      subRegionUrl: '',
      subRegionName: 'Tất cả',
    };

    if (req) {
      referer = req.headers['Referrer'];
      cookieLocation = req.cookies['location'] ? req.cookies['location'] : 'toan-quoc';
      if (query.ref) {
        referer = query.ref;
      }

      regionLocation = req.cookies['regionParams'];
      if (!regionLocation) {
        regionLocation = {
          regionValue: 0,
          regionUrl: 'toan-quoc',
          regionName: 'Toàn quốc',
          subRegionValue: 0,
          subRegionUrl: '',
          subRegionName: 'Tất cả',
        };
      } else {
        regionLocation = JSON.parse(regionLocation);
      }
    }

    const [
      { value: banners = {} },
      { value: seoData = {} },
      { value: catBlog = {} },
      { value: collections = {} },
      { value: shortcuts = {} },
      { value: recruitmentHubConfig = {} },
    ] = await Promise.allSettled([
      getBanners(),
      getSeo(regionLocation),
      getCatBlog(),
      getJobCollection('JOB_HOMEPAGE-VLT_COLLECTION'),
      getQuickShortCut(),
      getJobCollection('JOB_HOMEPAGE-RECRUITMENT_DASHBOARD'),
    ]);

    const displayCats = [1210, 1081, 1209, 1211, 1213];
    const sortCats =
      catBlog?.data?.length > 0
        ? catBlog.data
            .filter((c) => displayCats.indexOf(c.id) > -1)
            .sort((a, b) => displayCats.indexOf(a.id) - displayCats.indexOf(b.id))
        : [];

    await store.dispatch(loadConfigForm());
    await store.dispatch(getRegions());

    return {
      seo: seoData,
      banners,
      referer,
      isMobile,
      isServer,
      cookieLocation,
      collections,
      shortcuts,
      blogCats: sortCats,
      recruitmentHubConfig,
    };
  }

  render() {
    return <Home {...this.props} />;
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    config: state.config,
    theme: state.theme || {},
  };
};

export default connect(mapStateToProps, null)(withLayout(Index));
